import { useNavigate, useParams } from 'react-router-dom';

import { Icon } from '@/new/components/icon';
import { Button } from '@/new/components/shadcn/button';
import {
  Empty,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
  EmptyDescription,
  EmptyContent,
} from '@/new/components/shadcn/empty';

export function NoAnswer() {
  const { matterId, subsetId } = useParams();
  const navigate = useNavigate();

  const onNewSearchClick = () => {
    navigate(`/matters/${matterId}/subsets/${subsetId}/kim`);
  };

  return (
    <div className="flex w-full items-center justify-center p-6">
      <Empty>
        <EmptyHeader>
          <EmptyMedia variant="icon">
            <Icon className="lucide--alert-circle h-5 w-5" />
          </EmptyMedia>
          <EmptyTitle>Unable to process answer</EmptyTitle>
          <EmptyDescription>We couldn't process your request. Please try again.</EmptyDescription>
        </EmptyHeader>
        <EmptyContent>
          <Button variant="primary" size="default" onClick={onNewSearchClick} className="gap-2">
            Try again
            <Icon className="lucide--arrow-right h-4 w-4" />
          </Button>
        </EmptyContent>
      </Empty>
    </div>
  );
}
